const Partner = () => import(/* webpackChunkName: "Partner" */ '@/assets/js/src/modules/partner/_views/Partner.vue')

export default [
    { name: 'PartnerRoute', path: '/partner', meta: { uiType: 'Overlay', }, component: Partner, },
]